import React from 'react';
import { css } from '@emotion/core';
import RowTitle from './RowTitle';

const minilistScroll = css`
  margin: 0 15px 15px;
  overflow-x: scroll;
  overflow-y: hidden;
`;

const minilistContent = css`
  white-space: nowrap;
`;

export default class MiniList extends React.PureComponent {
  renderItems() {
    let { items, title, Item } = this.props;

    return <div css={minilistScroll}>
      <div css={minilistContent}>
        {
          items.map((w) => {
            return <Item key={`mini-${title}-${w.id}`} {...w} />;
          })
        }
      </div>
    </div>;
  }

  renderLoading() {
    let { ItemPlaceholder } = this.props;

    return <div css={minilistScroll}>
      <div css={minilistContent}>
        {
          [0, 1, 2, 3, 4, 5].map((i) => {
            return <ItemPlaceholder key={i} />;
          })
        }
      </div>
    </div>;
  }

  render() {
    let { items, title, failedToLoad } = this.props;

    if (failedToLoad) {
      return null;
    }

    return <div>
      <RowTitle title={title} />
      {items && items.length > 0 && this.renderItems() || this.renderLoading()}
    </div>;
  }
}